export const OPTIONS_MIN_WIDTH = "500px";
export const OPTIONS_MAX_HEIGHT = 500;

export const ALL_TASKS = "All tasks";

export const SLOT_PROPS = {
  listbox: { sx: { maxHeight: OPTIONS_MAX_HEIGHT } },
  paper: {
    sx: {
      width: "max-content",
      minWidth: "100%",
    },
  },
  renderInput: {
    TextField: {
      slotProps: {
        input: {
          sx: {
            fontSize: 12,
            pr: "0 !important", // "0" right-padding because the "clear" & "arrow" icons are hidden (to make space for the text)
          },
        },
      },
    },
  },
};
